import api from './api.ts';
import {resolveMembersBaseUrl} from './membersApi.ts';

export interface OnboardingDraft {
  person_type?: 'PF' | 'PJ';
  legal_name?: string;
  cpf_cnpj?: string;
  birth_date?: string | null;
  company_type?: string | null;
  income_value?: string;
  address?: string;
  address_number?: string;
  complement?: string | null;
  province?: string;
  postal_code?: string;
  city?: string;
  state?: string;
  bank_code?: string;
  bank_agency?: string;
  bank_agency_digit?: string | null;
  bank_account?: string;
  bank_account_digit?: string;
  bank_account_type?: 'CHECKING' | 'SAVINGS';
  bank_holder_name?: string;
  bank_holder_cpf_cnpj?: string;
}
export interface OnboardingState {
  revision: number;
  step: number;
  status: 'draft' | 'awaiting_activation' | 'submitted' | 'reconciliation_required';
  draft: OnboardingDraft;
  consent: boolean;
  consent_version: string;
  submitted_at: string | null;
  locked: boolean;
  provisioning_status: string;
}
const base = '/api/members/registration';
const connection = () => ({baseURL: resolveMembersBaseUrl(window.location)});
const mutation = (token: string) => ({...connection(), headers: {'X-Members-CSRF': token}});
export const membersOnboardingApi = {
  get: async () => (await api.get<OnboardingState>(base, connection())).data,
  save: async (data: {revision: number; step: number; draft: OnboardingDraft; consent?: boolean}, token: string) => (await api.put<OnboardingState>(base, data, mutation(token))).data,
  submit: async (revision: number, consentVersion: string, token: string) => (await api.post<OnboardingState>(`${base}/submit`, {revision, consent: true, consent_version: consentVersion}, mutation(token))).data,
};

/** Aceita BRL digitado e decimal canônico sem arredondar com ponto flutuante. */
export function normalizeIncome(value: string): string | null {
  const input = value.trim();
  let canonical: string;
  if (/^\d{1,3}(\.\d{3})+(,\d{1,2})?$/.test(input)) canonical = input.replace(/\./g, '').replace(',', '.');
  else if (/^\d+(,\d{1,2})?$/.test(input)) canonical = input.replace(',', '.');
  else if (/^\d+\.\d{1,2}$/.test(input)) canonical = input;
  else return null;
  const [integer, fraction = ''] = canonical.split('.');
  return `${integer.replace(/^0+(?=\d)/, '')}.${fraction.padEnd(2, '0')}`;
}
export const normalizeDocument = (value: string) => value.replace(/[.\-/\s]/g, '').toUpperCase();
